import { useState } from "react";
import api from "../api/api";

export default function MeetingsNotes() {

  const [form, setForm] = useState({
    meeting_id: "",
    content: ""
  });

  const [notes, setNotes] = useState([]);

  // LOAD NOTES
  const loadNotes = async () => {
    try {
      const res = await api.get("/meeting-note");
      setNotes(res.data || []);
    } catch (err) {
      console.log(err);
      alert("Error loading notes");
    }
  };

  // SAVE NOTE
  const saveNote = async () => {
    const { meeting_id, content } = form;

    if (!meeting_id || !content) {
      return alert("All fields are mandatory");
    }

    try {
      const res = await api.post("/meeting-note", form);

      alert("Note Added");

      // latest top
      setNotes([res.data, ...notes]);

      setForm({
        meeting_id: "",
        content: ""
      });

    } catch (err) {
      console.log(err);
      alert("Error saving note");
    }
  };

  return (
    <div className="min-h-screen -mt-10">

      {/* TITLE */}
      <div className="mb-8">
        <h2 className="text-4xl text-[#030244] text-center font-semibold">
          Meeting Notes
        </h2>
      </div>

      {/* FORM */}
      <div className="w-full mx-auto max-w-lg bg-white shadow-xl p-8 rounded-xl border mb-8">

        <h3 className="text-2xl font-semibold mb-6 text-center">
          Add New Note
        </h3>

        <div className="flex flex-col gap-4">

          <input
            className="border p-3 rounded focus:outline-none focus:ring-1 focus:ring-gray-500"
            placeholder="Enter Meeting ID"
            value={form.meeting_id}
            onChange={(e) =>
              setForm({ ...form, meeting_id: e.target.value })
            }
          />

          <textarea
            className="border p-3 rounded h-32 resize-none focus:outline-none focus:ring-1 focus:ring-gray-500"
            placeholder="Write meeting notes..."
            value={form.content}
            onChange={(e) =>
              setForm({ ...form, content: e.target.value })
            }
          />

          <div className="flex justify-center gap-4 mt-4">

            <button
              onClick={saveNote}
              className="bg-[#030244] hover:bg-[#040261] text-white px-6 py-2 rounded text-lg"
            >
              Save Note
            </button>

            <button
              onClick={loadNotes}
              className="bg-green-700 hover:bg-green-600 text-white px-6 py-2 rounded text-lg"
            >
              Load Notes
            </button>

          </div>

        </div>
      </div>

      {/* TABLE */}
      <div className="w-full max-w-5xl mx-auto bg-white mt-12 shadow-xl rounded-xl border overflow-hidden">

        <table className="w-full min-w-[700px]">

          <thead className="bg-[#030244] text-white text-xl">
            <tr>
              <th className="p-3 border font-medium">Note ID</th>
              <th className="p-3 border font-medium">Meeting ID</th>
              <th className="p-3 border font-medium">Content</th>
            </tr>
          </thead>

          <tbody>
            {notes.length === 0 ? (
              <tr>
                <td colSpan="3" className="text-center p-4 text-xl">
                  No Notes Found
                </td>
              </tr>
            ) : (
              notes.map((n) => (
                <tr key={n.meetingnote_id} className="border-b text-lg">

                  <td className="p-3 border text-center text-gray-700">
                    {n.meetingnote_id}
                  </td>

                  <td className="p-3 text-center border text-gray-700">
                    {n.meeting_id}
                  </td>

                  <td className="p-3 border text-center text-gray-700">
                    {n.content}
                  </td>

                </tr>
              ))
            )}
          </tbody>

        </table>

      </div>

    </div>
  );
}